import dayjs from "dayjs";

import { getDollarValue } from "../../helpers/currency";

const fmtDate = (d) => d.format("YYYY-MM-DD");

export const periodToRange = (period = "1Q") => {
  const today = dayjs().utc();
  switch (period) {
    case "1Y": {
      const start = today.startOf("year");
      const end = today.endOf("year");
      return { startDate: fmtDate(start), endDate: fmtDate(end) };
    }
    case "3M": {
      const start = today.subtract(1, "month").startOf("month");
      const end = today.add(1, "month").endOf("month");
      return { startDate: fmtDate(start), endDate: fmtDate(end) };
    }
    case "6W": {
      const start = today.startOf("week").subtract(2, "week");
      const end = today.endOf("week").add(3, "week");
      return { startDate: fmtDate(start), endDate: fmtDate(end) };
    }
    case "1Q":
    default: {
      const qIdx = Math.ceil((today.month() + 1) / 3);
      const start = today.month((qIdx * 3) - 2).startOf("month");
      const end = today.month(qIdx * 3).endOf("month");
      return { startDate: fmtDate(start), endDate: fmtDate(end) };
    }
  }
};

const num = (n) => (n ?? 0).toLocaleString();

const fmtRange = (range) => {
  if (!range?.start || !range?.end) return "";
  return `${dayjs(range.start).format("MMM DD")} – ${dayjs(range.end).format(
    "MMM DD, YYYY",
  )}`;
};

const metric = (metrics, key) => metrics[key] || { value: 0, rate: null };

export const getStatCards = (summary = {}) => {
  const metrics = summary.metrics || {};
  const days = summary.days || 30;
  const rateProps = { label: `vs prev ${days}d` };
  const rangeLabel = fmtRange(summary.range);
  const m = (key) => metric(metrics, key);

  return [
    {
      label: "Orders Revenue",
      value: getDollarValue(m("ordersRevenue").value || 0),
      rate: m("ordersRevenue").rate,
    },
    {
      label: "Work Order Revenue",
      value: getDollarValue(m("workOrdersRevenue").value || 0),
      rate: m("workOrdersRevenue").rate,
    },
    {
      label: "New Customers",
      value: num(m("customersCount").value),
      rate: m("customersCount").rate,
    },
    {
      label: "New Parts",
      value: num(m("partsCount").value),
      rate: m("partsCount").rate,
    },
    {
      label: "Shipments",
      value: num(m("shipmentsCount").value),
      rate: m("shipmentsCount").rate,
    },
    {
      label: "Labor Tickets",
      value: num(m("laborCount").value),
      rate: m("laborCount").rate,
    },
  ].map((card) => ({ ...card, rateProps, rangeLabel }));
};

export const DASHBOARD_VIEWS = [
  { id: "orders", label: "Orders" },
  { id: "workOrders", label: "Work Orders" },
  { id: "parts", label: "Parts" },
  { id: "customers", label: "Customers" },
  { id: "shipments", label: "Shipments" },
  { id: "labor", label: "Labor Tickets" },
];
